import React from 'react'
import "./ISBCintroVideo.css"

function ISBCintroVideo() {
  return (
    <center>
        <video  className='VidIntro33' src='https://d2ou8hgu4mxzkl.cloudfront.net/video/ISBC+Hindi+.MP4'autoPlay controls/>
    </center>
  )
}

export default ISBCintroVideo